import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PageHeaderProps {
  title: string;
  onBack?: () => void;
  rightAction?: ReactNode;
}

export default function PageHeader({ title, onBack, rightAction }: PageHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-2 px-4 py-3 border-b border-border">
      <Button
        variant="ghost"
        size="icon"
        className="rounded-xl !bg-transparent text-foreground hover:bg-secondary"
        onClick={onBack ?? (() => navigate(-1))}
      >
        <ArrowLeft className="h-6 w-6" />
      </Button>
      <h1 className="font-display text-lg font-bold flex-1">{title}</h1>
      {rightAction}
    </div>
  );
}
